<template>
  <div class="container">
    <h3>Athletes</h3>
    <div class="user-cards">
      <user-card v-for="user in users" :key="user.id" :title="`${user.firstname} ${user.lastname}`" :url="user.profile_medium" :id="user.id"></user-card>
    </div>
  </div>
</template>


<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const UserRepository = RepositoryFactory.get("users");

import UserCard from "@/components/Cards/UserCard.vue";

export default {
  components: { UserCard },
  data() {
    return {
      users: [],
    };
  },
  created() {
    this.fetchUsers().then((result) => (this.users = result));
  },
  methods: {
    async fetchUsers() {
      try {
        // Fetching auth data from the server
        const { data } = await UserRepository.get();
        return data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style scoped>
@import "../assets/styles/bootstrap-overrides.css";
.bg-secondary {
  background-color: #f5f6ff !important;
}

.user-cards {
display: grid;
grid-template-columns: repeat(2, 1fr);
grid-template-rows: repeat(5, 1fr);
grid-column-gap: 10px;
grid-row-gap: 10px;
}

</style>